import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  FileImageOutlined,
  FileOutlined,
  FileSearchOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import React from 'react';

export const STATUS_CONFIG = {
  to_qualify: {
    label: 'À qualifier',
    color: 'default',
    ribbonColor: 'gray',
  },
  to_validate: {
    label: 'À valider',
    color: 'processing',
    ribbonColor: 'blue',
  },
  validated: {
    label: 'Validé',
    color: 'success',
    ribbonColor: 'green',
  },
  rejected: {
    label: 'Rejeté',
    color: 'error',
    ribbonColor: 'red',
  },
  archived: {
    label: 'Archivé',
    color: 'default',
    ribbonColor: 'gray',
  },
};

export const TYPE_CONFIG = {
  image: {
    label: 'Image',
    color: 'blue',
    extensions: ['jpg', 'jpeg', 'png', 'gif', 'svg'],
  },
  video: {
    label: 'Vidéo',
    color: 'green',
    extensions: ['mp4', 'avi', 'mov', 'wmv'],
  },
  document: {
    label: 'Document',
    color: 'orange',
    extensions: ['pdf', 'doc', 'docx', 'xls', 'xlsx'],
  },
  audio: {
    label: 'Audio',
    color: 'purple',
    extensions: ['mp3', 'wav', 'ogg'],
  },
};

export const PAGINATION_OPTIONS = {
  large: ['8', '12', '20', '40'],
  small: ['12', '24', '48', '72'],
  list: ['10', '20', '50', '100'],
};

export const THUMBNAIL_SIZES = {
  small: 60,
  medium: 150,
  large: 200,
};

export const GRID_COLUMNS = {
  large: {
    xs: 24,
    sm: 12,
    md: 8,
    lg: 6,
  },
  small: {
    xs: 12,
    sm: 8,
    md: 6,
    lg: 4,
  },
};

// import { STATUS_CONFIG, TYPE_CONFIG } from './mediaConstants';

export const getTypeIcon = (type, size = 24) => {
  const iconStyle = { fontSize: size };

  switch (type) {
    case 'image':
      return <FileImageOutlined style={{ ...iconStyle, color: '#1890ff' }} />;
    case 'video':
      return <VideoCameraOutlined style={{ ...iconStyle, color: '#52c41a' }} />;
    case 'document':
      return <FileOutlined style={{ ...iconStyle, color: '#faad14' }} />;
    case 'audio':
      return <FileOutlined style={{ ...iconStyle, color: '#722ed1' }} />;
    default:
      return <FileOutlined style={iconStyle} />;
  }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case 'to_qualify':
      return <FileSearchOutlined style={{ color: '#fa8c16' }} />;
    case 'to_validate':
      return <ClockCircleOutlined style={{ color: '#1890ff' }} />;
    case 'validated':
      return <CheckCircleOutlined style={{ color: '#52c41a' }} />;
    case 'rejected':
      return <CloseCircleOutlined style={{ color: '#ff4d4f' }} />;
    case 'archived':
      return <DeleteOutlined style={{ color: '#bfbfbf' }} />;
    default:
      return null;
  }
};

export const getRibbonColor = (statusColor) => {
  const colorMap = {
    default: 'gray',
    processing: 'blue',
    success: 'green',
    error: 'red',
  };
  return colorMap[statusColor] || 'gray';
};

export const getTypeLabel = (type) => {
  return TYPE_CONFIG[type]?.label || type;
};

export const getTypeColor = (type) => {
  return TYPE_CONFIG[type]?.color || 'default';
};

export const getStatusLabel = (status) => {
  return STATUS_CONFIG[status]?.label || status;
};

export const getStatusColor = (status) => {
  return STATUS_CONFIG[status]?.color || 'default';
};

/** Description de la première issue non résolue (affichage carte / tooltips). */
export const getActiveIssueDescription = (media) => {
  const issues = media?.issues ?? [];
  const issue = issues.find((i) => !i.isResolved && i.description);
  return issue?.description ?? null;
};
